import { render, staticRenderFns } from "./AppLayoutTopBar.vue?vue&type=template&id=21a88d0a&"
import script from "./AppLayoutTopBar.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppLayoutTopBar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports